import { render, staticRenderFns } from "./OutrosTiposFinalPanel.vue?vue&type=template&id=062aca0d&scoped=true&"
import script from "./OutrosTiposFinalPanel.vue?vue&type=script&lang=js&"
export * from "./OutrosTiposFinalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062aca0d",
  null
  
)

export default component.exports